/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {Store} from '@gongxigames/framework/core';
import {FC, CanBeSignals, ContainerProps, getProp, $Container} from '@gongxigames/framework/core/fragments/BuilderY';
import {IHitArea, Point} from 'pixi.js';
import {ArrowButtonProps} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/components/slides/ArrowButton';

type ArrowsProps = ContainerProps & CanBeSignals<{
    activeIndex: number;
    setIndex: (i: number) => void;
    arrowsPosition: Point;
    hitArea: IHitArea | null;
    arrowButton: FC<ArrowButtonProps>;
}>;

const LEFT = 1;
const RIGHT = -1;
const X_DEFAULT = 200;
const Y_DEFAULT = -300;

export const $Arrows: FC<ArrowsProps> = (props) => {

    const x = Store.computed(() => getProp(props.arrowsPosition)?.x ?? X_DEFAULT);
    const xMinus = Store.computed(() => -x.value);
    const y = Store.computed(() => getProp(props.arrowsPosition)?.y ?? Y_DEFAULT);

    function onPress(delta: number): void {
        let activeIndex = getProp(props.activeIndex);
        const setIndex = getProp(props.setIndex);

        setIndex(activeIndex + delta);
    }

    const $ArrowButton = getProp(props.arrowButton);

    return <$Container {...props}>
        <$ArrowButton
            hitArea={props.hitArea}
            onPress={() => onPress(LEFT)}
            x={x}
            y={y}
        />
        <$ArrowButton
            hitArea={props.hitArea}
            onPress={() => onPress(RIGHT)}
            flip={true}
            x={xMinus}
            y={y}
        />
    </$Container>;
};
